import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  IconButton,
  InputAdornment,
  Stack,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

const ChangePasswordModal = ({
  open,
  onClose,
  onSubmit,
  isLoading = false,
}) => {
  const [formData, setFormData] = useState({
    current_password: "",
    password: "",
    password_confirmation: "",
  });

  const [showPassword, setShowPassword] = useState({
    current_password: false,
    password: false,
    password_confirmation: false,
  });

  const [error, setError] = useState("");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    setError("");
  };

  const togglePassword = (field) => {
    setShowPassword((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  const handleSubmit = async () => {
    if (
      !formData.current_password ||
      !formData.password ||
      !formData.password_confirmation
    ) {
      setError("Please fill in all fields.");
      return;
    }

    if (formData.password !== formData.password_confirmation) {
      setError("New password and confirmation do not match.");
      return;
    }

    try {
      await onSubmit({
        _method: "PUT",
        ...formData,
      });

      setFormData({
        current_password: "",
        password: "",
        password_confirmation: "",
      });

      setError("");
      onClose();
    } catch (err) {
      setError(
        err?.data?.message || err?.message || "Failed to change password.",
      );
    }
  };

  const fields = [
    { name: "current_password", label: "Current Password" },
    { name: "password", label: "New Password" },
    { name: "password_confirmation", label: "Confirm New Password" },
  ];

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Change Password</DialogTitle>

      <DialogContent>
        <Stack spacing={2.5} sx={{ pt: 1 }}>
          {fields.map((field) => (
            <TextField
              key={field.name}
              fullWidth
              required
              label={field.label}
              name={field.name}
              type={showPassword[field.name] ? "text" : "password"}
              value={formData[field.name]}
              onChange={handleChange}
              autoComplete="new-password"
              error={Boolean(error)}
              slotProps={{
                input: {
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => togglePassword(field.name)}
                        edge="end"
                        aria-label={`Toggle ${field.label}`}
                      >
                        {showPassword[field.name] ? (
                          <VisibilityOff />
                        ) : (
                          <Visibility />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                },
              }}
            />
          ))}

          {error && <div style={{ color: "red", fontSize: 14 }}>{error}</div>}
        </Stack>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} disabled={isLoading}>
          Cancel
        </Button>

        <Button variant="contained" onClick={handleSubmit} disabled={isLoading}>
          {isLoading ? "Updating..." : "Update Password"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChangePasswordModal;
